<template>
  <div class="image-drag-drop-upload">
    <!-- Edit modunda mevcut resim gösterimi -->
    <div v-if="existingImageUrl" class="row mb-3">
      <div class="col-lg-5">
        <img :src="existingImageUrl" :alt="$t('general.existing_image')" class="existing-image">
      </div>
    </div>

    <!-- Upload Area -->
    <div class="uploadOuter">
      <label class="btn btn-info" :for="uploadId">
        <i class="uil-upload"></i>
        {{ $t('general.upload') }}
      </label>
      <strong>{{ $t('general.or') }}</strong>
      <span 
        class="dragBox" 
        :class="{ 'draging': isDragging }"
        @drop.prevent="handleDrop"
        @dragenter.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @dragover.prevent
      >
        <i class="icon-feather-file-plus"></i>
        {{ dragDropText || $t('general.doc_file_drag_drop') }}
        <input 
          :id="uploadId" 
          :accept="accept" 
          type="file" 
          @change="handleFileChange"
        />
      </span>
    </div>

    <!-- Preview Area -->
    <div v-if="previewHtml" class="filePreview" v-html="previewHtml"></div>
  </div>
</template>

<script>
export default {
  name: "ImageDragDropUpload",
  props: {
    existingImageUrl: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: 'image/jpeg, image/jpg, image/png, image/gif'
    },
    dragDropText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isDragging: false,
      uploadId: `imageUpload_${Math.random().toString(36).substr(2, 9)}`,
      previewHtml: null,
      selectedFile: null
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.processFile(file);
      }
      this.isDragging = false;
    },
    handleDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.processFile(file);
      }
    },
    processFile(file) {
      this.selectedFile = file;
      
      const fileSize = this.defaultBytesToSize(file.size);
      const previewUrl = URL.createObjectURL(file);
      
      this.previewHtml = `
        <div class="file-info" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap; background: #f5f5f5; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
          <div style="white-space: nowrap;">${this.$t('general.format')}: <span style="font-weight: 600; color: #333;">${file.type}</span></div>
          <div style="white-space: nowrap;">${this.$t('general.document_name')}: <span style="font-weight: 600; color: #333;">${file.name}</span></div>
          <div style="white-space: nowrap;">${this.$t('general.size')}: <span style="font-weight: 600; color: #333;">${fileSize}</span></div>
        </div>
        <br>
        <div>
          <img src="${previewUrl}" alt="${this.$t('general.preview')}" style="max-width: 100%; max-height: 300px; object-fit: cover;" />
        </div>
      `;
      
      this.$emit('file-selected', file);
    },
    defaultBytesToSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    clearPreview() {
      this.previewHtml = null;
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    getFile() {
      return this.selectedFile;
    }
  }
};
</script>

<style scoped>
.image-drag-drop-upload {
  width: 100%;
}

.existing-image {
  max-width: 100%;
  max-height: 300px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid #ddd;
}

.uploadOuter {
  text-align: center;
  padding: 20px;
}

.uploadOuter strong {
  padding: 0 10px;
}

.dragBox {
  width: auto;
  padding: 0 10px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  transition: transform 0.3s;
  cursor: pointer;
}

.dragBox:hover {
  border-color: #999;
}

.dragBox.draging {
  transform: scale(1.05);
  border-color: #007bff;
  background-color: #f0f8ff;
}

.dragBox input[type="file"] {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  top: 0;
  left: 0;
  cursor: pointer;
}

.dragBox i {
  font-size: 24px;
  margin-right: 10px;
  vertical-align: middle;
}

.filePreview {
  margin-top: 15px;
}

</style>

